<template>
	<div class="right-control">
		<el-switch
			class="switch"
			v-model="isShow"
			:disabled="!permission"
			@change="change"
			:active-value="tableData.activeValue"
			:inactive-value="tableData.inactiveValue"
		></el-switch>

		<el-popover
			class="popover"
			placement="right"
			title=""
			width="600"
			trigger="click"
			@show="showPopover"
		>
			<div class="el-popover__title">系统权限</div>
			<div class="right">
				<div class="item" v-for="item in rightControlList" :key="item.id">
					<div class="name">{{ item.name }}</div>
					<div class="switch">
						<el-switch
							v-model="item.flagEnable"
							active-color="#409eff"
							inactive-color="#dcdfe6"
							:disabled="!permission"
							@change="switchChange(item.id)"
						>
						</el-switch>
					</div>
				</div>
			</div>
			<div class="el-popover__title">功能权限</div>
			<div class="right">
				<div class="item" v-for="item in functionList" :key="item.id">
					<div class="name">{{ item.name }}</div>
					<div class="switch">
						<el-switch
							v-model="item.flagEnable"
							active-color="#409eff"
							inactive-color="#dcdfe6"
							:disabled="!permission"
							@change="switchChange(item.id)"
						>
						</el-switch>
					</div>
				</div>
			</div>
			<ig-icon slot="reference" name="brush"></ig-icon>
		</el-popover>
	</div>
</template>

<script>
import customer from '@/backend/services/account/customer.js';
export default {
	name: 'messageSwitch',
	props: {
		tableData: Object,
		scope: Object,
	},
	data() {
		return {
			isShow: this.scope.row[this.tableData.bind],
			rightControlList: [],
			functionList: [],
		};
	},
	computed: {
		permission() {
			return this.getPermission(this.$permissionData.systemAccess.englishName);
		},
	},
	watch: {
		'scope.row': {
			deep: true,
			handler() {
				this.isShow = this.scope.row[this.tableData.bind];
			},
		},
	},
	methods: {
		change(e) {
			this.tableData.event && this.tableData.event(this.scope.row, e);
		},
		async showPopover() {
			this.rightControlList = [];
			this.functionList = [];
			let res = await customer.rightControlList({
				serviceId: this.scope.row.id,
			});
			res.data.forEach(item => {
				if (item.versionName == 'Pro') item.name = `${item.name}（${item.versionName}）`;
				if (item.permissionsType == 0) {
					this.rightControlList.push(item);
				} else {
					this.functionList.push(item);
				}
			});
		},
		async switchChange(id) {
			let res = await customer.setRightControl({
				id,
			});
			if (res.status === 204) {
				this.$message.success('权限设置成功');
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.right-control {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;

	.popover {
		margin: 0 20px;

		.iconfont {
			font-size: 18px;
		}
	}
}

.right {
	padding: 10px 0;
	padding-left: 20px;

	.item {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.name,
		.date {
			flex: 1;
			// 单行溢出
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.name {
			text-align: left;
		}

		.date {
			text-align: center;
		}

		.switch {
			text-align: right;
		}
	}
}
</style>
